import React, { useContext } from 'react';

import { ModalTransition } from '@atlaskit/modal-dialog';

import { DialogsContext } from './DialogsContext';
import { type DialogEntry } from './types';

/**
 * DialogRenderer is used to render actual Dialog inside AK ModalTransition.
 */
export default function DialogRenderer(props: DialogEntry): React.JSX.Element | null {
	const { DialogComponent, isOpen, onClose, dialogProps } = props;
	const { closeDialog } = useContext(DialogsContext);

	if (!DialogComponent) {
		return null;
	}

	const handleCloseDialog = () => {
		closeDialog();
		if (onClose) {
			onClose();
		}
		if (dialogProps?.onClose) {
			dialogProps.onClose();
		}
	};

	return (
		<ModalTransition>
			{isOpen && <DialogComponent {...dialogProps} onClose={handleCloseDialog} />}
		</ModalTransition>
	);
}
